import project1 from '../images/projectImages/reactwithtailwind/weatherapp.png'
import project2 from '../images/projectImages/reactwithtailwind/mealmateapp.png'
import project3 from '../images/projectImages/reactwithtailwind/SmartProductivityDashboard.png'
import project4 from '../images/projectImages/reactwithtailwind/StyleCraft.png'
import project5 from '../images/projectImages/reactwithtailwind/multiPageDashboard.png'
import project6 from '../images/projectImages/reactwithtailwind/jobAppTracker.png'

const ReactwithtailwindList = [
{
    id: '1',
    projectImage: project1,
    title: 'Wander Wise',
    description: "This is a web app that helps users make traveling decisions",
    liveDemoLink: "https://jojo588.github.io/smartTravelPlanner/",
    sourceCode: "https://github.com/Jojo588/smartTravelPlanner.git"

  },
  {
    id: '2',
    projectImage: project2,
    title: 'meal mate',
    description: "This is a web app that helps users keep track of food item expiry dates",
    liveDemoLink: "https://jojo588.github.io/mealMate/",
    sourceCode: "https://github.com/Jojo588/mealMate.git"

  },
  {
    id: '3',
    projectImage: project3,
    title: 'Smart Productivity Dashboard',
    description: "This is a web app that helps users check time and weather, create todo list and write on some sticky notes",
    liveDemoLink: "https://jojo588.github.io/SmartProductivityDashboard/",
    sourceCode: "https://github.com/Jojo588/SmartProductivityDashboard.git"

  },
  {
    id: '4',
    projectImage: project4,
    title: 'StyleCraft',
    description: "This is a web app that helps users customize kente cloths into dress designs",
    liveDemoLink: "https://jojo588.github.io/StyleCraft/",
    sourceCode: "https://github.com/Jojo588/StyleCraft.git"

  },
  {
    id: '5',
    projectImage: project5,
    title: 'FreelancePro',
    description: "This is a multi-Page Dashboard for a fictional freelance client",
    liveDemoLink: "https://multi-page-dashboard-six.vercel.app/",
    sourceCode: "https://github.com/Jojo588/multiPageDashboard.git"

  },
  {
    id: '6',
    projectImage: project6,
    title: 'JobTracker',
    description: "This is a web app used to track users job applications",
    liveDemoLink: "https://job-application-tracker-delta-bice.vercel.app/",
    sourceCode: "https://github.com/Jojo588/jobApplicationTracker.git"

  },

  ];
export default ReactwithtailwindList;
